var cursor = document.querySelector(".cursor");
var onMouseMove = function () {
  cursor.style.top = event.y + "px";
  cursor.style.left = event.x + "px";
};
document.addEventListener("mousemove", onMouseMove);
